"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectBrowserLocale = void 0;
const DEFAULT_LOCALE = 'fr';
const AVAILABLE_LOCALES = ['en', 'fr'];
const langToLocale = (language) => language && language.length > 0 ? language.split('-')[0].toLowerCase() : null;
const detectBrowserLocale = () => {
    if (typeof window === 'undefined') {
        return DEFAULT_LOCALE;
    }
    if (window.navigator.languages) {
        const browserLanguage = window.navigator.languages.find((lang) => {
            const locale = langToLocale(lang);
            if (!locale) {
                return false;
            }
            return AVAILABLE_LOCALES.includes(locale);
        });
        return browserLanguage ? langToLocale(browserLanguage) : DEFAULT_LOCALE;
    }
    if (window.navigator.language) {
        return langToLocale(window.navigator.language);
    }
    return DEFAULT_LOCALE;
};
exports.detectBrowserLocale = detectBrowserLocale;
//# sourceMappingURL=locale.js.map